module.exports = __webpack_public_path__ + "assets/media/lunch.67dba64d.mp3";